import { Footer } from '@hg/stylizator/components'
import * as React from 'react'

import { useGlobalState } from 'app/store'

const HoneygainSdkFooter: React.FC = () => {
  const [menuItems] = useGlobalState('honeygainSdkFooterMenu')
  const [blocks] = useGlobalState('reusableBlocks')
  const footerBlock = blocks.get('honeygain-components/honeygain-sdk-footer')
  const attrs = footerBlock?.attrs ?? {}

  return (
    <Footer
      product={attrs.product}
      copyright={attrs.copyright}
      description={attrs.description}
      footerMenu={{
        firstMenu: !!attrs.firstMenuTitle ? [{ name: attrs.firstMenuTitle }, ...menuItems[0]] : menuItems[0],
        secondMenu: !!attrs.secondMenuTitle ? [{ name: attrs.secondMenuTitle }, ...menuItems[1]] : menuItems[1],
        thirdMenu: !!attrs.thirdMenuTitle ? [{ name: attrs.thirdMenuTitle }, ...menuItems[2]] : menuItems[2],
        fourthMenu: !!attrs.fourthMenuTitle
          ? [{ name: attrs.fourthMenuTitle }, ...(menuItems?.[3] ?? [])]
          : menuItems?.[3] ?? [],
      }}
      socials={{}}
      stores={[]}
    />
  )
}

export default React.memo(HoneygainSdkFooter)
